import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  padding: 0px 8px;
  grid-template-columns: 1fr 1fr;
`;

export const ContentItem = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
`;
